function newPrompt(message) {
	/* jshint ignore:start */
	return prompt(message);
	/* jshint ignore:end */
}

module.exports = newPrompt;